<template>
    <div>
        <el-form
        :model="selectForm"
        ref="ruleForm"
        label-width="80px"
        
      >
         <el-row :gutter="24">
             <el-col span="6">
                <el-form-item label="标准名称" prop="name">
                        <el-input clearable v-model="selectForm.name" placeholder="标准名称" maxlength="20"></el-input>
                </el-form-item>
            </el-col>
            
            <el-col span="18">
                <div style="float:right">
                              <el-button type="primary" @click="search" icon="el-icon-search"  size="small"> 搜索 </el-button>
                              <el-button @click="searchClear" icon="el-icon-delete" size="small"> 清空 </el-button>
                </div>
            </el-col>
          
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            ref="crud"
            @current-change="currentChange"
            @size-change="sizeChange"
            @on-load="onLoad()"
            @refresh-change="onLoad()">
             
            <template slot="choice" slot-scope="scope">
                <el-radio v-model="radio" :label="scope.row" > {{' '}}</el-radio>
            </template>
           
        </avue-crud>
        <div class="btnArea" style="text-align:right">
            <el-button type="primary" size="small" @click="submitData">提交</el-button>
            <el-button size="small" @click="cancelOperate">取消</el-button>
         </div>
       </el-row>
        </el-form>
    </div>
</template>

<script>
import {getDeviceMaintennanceStandardList} from '@/api/crmedical/device/deviceMaintenaceStandard';
export default {
    props:["projectId"],
  data() {
    return {
      radio: '',
      data: [], //数据源列表
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectForm: {},
      loading: false,
      option: {
        page: true,
        height: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '选择',
            prop: 'choice',
            align: 'center',
            slot: true,
          },
          {
            label: '标准名称',
            prop: 'name',
            searchSpan:6,
          },
          {
            label: '创建人',
            prop: 'realName',
          },
          {
            label: '创建时间',
            prop: 'createTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
        ],
      },
    };
  },
  methods: {
    sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        currentChange(currentPage) {
            this.page.currentPage = currentPage;
        },
      search(){
          this.page.currentPage = 1 
          this.onLoad()
      },
      searchClear(){
          this.$set(this.selectForm,"name",'')
      },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      console.log('维保projectId',this.projectId)
      getDeviceMaintennanceStandardList(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize ,status:1,projectId:this.projectId},
          this.selectForm
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submitData(){
       this.$emit('choiceData', this.radio); 
    },
    cancelOperate(){
      this.$emit("cancelOperate")
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table--small{
  height:300px!important;
}
</style>
